import * as types from './actionTypes';
import {apiPost, apiRequest} from '../utils/request';
import {toastr} from 'react-redux-toastr';
import { getErrorMessage, mustBeArray, requestHasError } from '../utils/lib';

export function listCollectionHistorySuccess({items}){
  return {type: types.LIST_COLLECTION_HISTORY, items};
}

export function clearCollectionHistorySuccess(){
  return {type: types.CLEAR_COLLECTION_HISTORY, items: []};
}

export function listClientLocationsSuccess({items}){
  return {type: types.LIST_CLIENT_LOCATIONS, items};
}

export function clearClientLocationsSuccess(){
  return {type: types.LIST_CLIENT_LOCATIONS, items: []};
}

export function listClientLocationsDeliverySuccess({items}){
  return {type: types.LIST_CLIENT_LOCATIONS_DELIVERY, items};
}

export function clearClientLocationsDeliverySuccess(){
  return {type: types.LIST_CLIENT_LOCATIONS_DELIVERY, items: []};
}

export function listCollectionHistory() {
  return function (dispatch) {
    return apiRequest(`/api/pickups/completed-collections?limit=5`)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error: ${getErrorMessage({x})}`);
          dispatch(clearCollectionHistorySuccess());
        } else {
          dispatch(listCollectionHistorySuccess({items: mustBeArray(x && x.data && x.data.locations)}));
        }
        return x;
      });
  };
}

export function clearCollectionHistory() {
  return function (dispatch) {
    return dispatch(clearCollectionHistorySuccess());
  };
}

/**
 * Client Locations only differ with requestType param
 * 
 * Handles both collection and delivery for upcoming requests 
 * 
 * @param {"Collection" | "Fresh Oil"} requestType 
 * @returns 
 */
export function listClientLocations(requestType = "Collection", locationId = null) {
  return function (dispatch) {
    let url = `/api/pickups/for-urgent-collections?`;
    const params = new URLSearchParams('');
    params.set('requestType',requestType);
    params.set('locationId', locationId);
    url += params.toString();
    return apiRequest(url)
      .then(x => {
        if (requestHasError({x})) {
          toastr.error(`Error: ${getErrorMessage({x})}`);
          if(requestType === 'Collection'){
            dispatch(clearClientLocationsSuccess());
          }
          else if(requestType === 'Fresh Oil'){
            dispatch(clearClientLocationsDeliverySuccess());
          }
        } else {
          if(requestType === 'Collection'){
            dispatch(listClientLocationsSuccess({
              items: mustBeArray(x && x.data && x.data.locations)
            }));
          }
          else if(requestType === 'Fresh Oil'){
            dispatch(listClientLocationsDeliverySuccess({
              items: mustBeArray(x && x.data && x.data.locations)
            }));
          }
        }
        return x;
      });
  };
}

export function clearClientLocations() {
  return function (dispatch) {
    return dispatch(clearClientLocationsSuccess());
  };
}

export function clearClientLocationsDelivery() {
  return function (dispatch) {
    return dispatch(clearClientLocationsDeliverySuccess());
  };
}

export function saveUrgentCollectionRequest({payLoad}) {
  return function (dispatch) {
    toastr.info('Saving Urgent Collection Request');
    return apiPost(`/api/clientrequests/urgent-collection`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          let message = `Error: ${getErrorMessage({x})}`;
          toastr.error(message);
        }
        return x; 
      });
  };
}

export function saveUrgentDeliveryRequest({payLoad}) {
  return function (dispatch) {
    toastr.info('Saving Delivery Request');
    return apiPost(`/api/clientrequests/deliveries/urgent`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          let message = `Error: ${getErrorMessage({x})}`;
          toastr.error(message);
        }
        return x; 
      });
  };
}

export function saveUrgentTankSwapRequest({payLoad}) {
  return function (dispatch) {
    toastr.info('Saving Tank Swap Request');
    return apiPost(`/api/clientrequests/tank-swap`, payLoad)
      .then(x => {
        if (requestHasError({x})) {
          let message = `Error: ${getErrorMessage({x})}`;
          toastr.error(message);
        }
        return x; 
      });
  };
}